<script lang="ts" setup>
import type { ICellRendererParams } from 'ag-grid-community';
import type { PropType} from 'vue';
import { computed, ref } from 'vue';
import ManagerSelect from '@/components/common/ManagerSelect.vue';
import type { OrganisationNode } from '@sysarb/sysarb-types/services/v1/organisation-node';

type ExtendedParams = ICellRendererParams<OrganisationNode, void> & {
    id: (params: ICellRendererParams) => string;
    orgNode: (params: ICellRendererParams) => OrganisationNode | null;
    updateManager: (managerId: string | null, orgNode: OrganisationNode | null) => string | OrganisationNode | null;
};

const props = defineProps({
    params: {
        type: Object as PropType<ExtendedParams>,
        required: true
    }
});

const id = computed(() => (typeof props.params.id === 'function' ? props.params.id(props.params) : props.params.id));
const orgNode = computed(() => (typeof props.params.orgNode === 'function' ? props.params.orgNode(props.params) : props.params.orgNode));

const updatedEmployeeId = ref<string | undefined | null>('none');
const employeeId = computed(() => (updatedEmployeeId.value !== 'none' ? updatedEmployeeId.value : id.value));
const updateKey = ref(0);

function closePopup():void {
    props.params.api.stopEditing();
}

function updateManager(managerId: string | null): void {
    updateKey.value++;
    updatedEmployeeId.value = managerId;

    if (typeof props.params.updateManager === 'function') {
        props.params.updateManager(managerId, orgNode.value);

        closePopup();
    }
}
</script>

<template>
    <div @blur="closePopup">
        <ManagerSelect
            :id="employeeId"
            :key="updateKey"
            class="sy-manager-container"
            @change="updateManager"
        />
    </div>
</template>
<style scoped>
.sy-manager-container {
    min-width: 300px;
    max-width: 300px;
}
</style>
